import { AlertCircle, Info, RefreshCw, Wallet } from 'lucide-react';
import { useOpenRouterBalance } from '../../hooks/useOpenRouterBalance';
import '../../styles/OpenRouterBalanceWidget.css';

function fmt(n) {
  if (typeof n !== 'number') return '—';
  return `$${n.toFixed(4)}`;
}

// What this widget covers + what it does NOT cover. Shown verbatim in the
// hover tooltip on the info icon so admins don't think "$0.05 today" means
// total AI spend — voice + embeddings are separate billing channels.
const SCOPE_NOTE = [
  'این اعداد فقط مصرف OpenRouter را نشان می‌دهد:',
  '• چت متنی مشتری، چت آموزش ادمین، خلاصه‌سازی پس از تماس،',
  '  استخراج گزاره از سند، تثبیت دانش',
  '• شورای بازرسی، شورای ضربت، ارتش تک‌نفره',
  '',
  'پوشش نمی‌دهد:',
  '• مکالمات صوتی (OpenAI Realtime / Gemini Live ـ صورت‌حساب جدا)',
  '• Embedding (مستقیماً از OpenAI ـ صورت‌حساب جدا)',
].join('\n');

export default function OpenRouterBalanceWidget() {
  const { balance, loading, error, refresh } = useOpenRouterBalance();

  if (error === 'not-authenticated') return null;

  return (
    <div className={`openrouter-widget${error ? ' error' : ''}`} dir="rtl">
      <Wallet size={16} />
      <span className="widget-label" title={SCOPE_NOTE}>
        OpenRouter
        <Info size={11} className="widget-info-icon" />
      </span>
      {error ? (
        <span className="widget-text">
          <AlertCircle size={13} />
          {String(error).slice(0, 60)}
        </span>
      ) : loading ? (
        <span className="widget-text">در حال خواندن…</span>
      ) : (
        <span className="widget-text">
          <span className="widget-remaining">{fmt(balance?.remaining)}</span>
          <span className="widget-divider">|</span>
          <span className="widget-usage">مصرف: {fmt(balance?.total_usage)}</span>
        </span>
      )}
      <button type="button" className="widget-refresh" onClick={refresh} title="تازه‌سازی">
        <RefreshCw size={12} />
      </button>
    </div>
  );
}
